import React from "react";
import { Button } from "@material-ui/core";
import Image from "../../../../components/common/Image";

interface FeedButtonprop {
  svg: any;
  type: string;
  name: string;
  form: any;
  onUploadImage: any;
  accept: string;
  value: any;
  id: string;
}

function FeedButton(props: FeedButtonprop) {
  const { ref, onChange, ...registerProps } = props.form.register(props.name, {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
      props.onUploadImage(event);
    },
  });

  return (
    <ul>
      <li>
        <label htmlFor={props.id} className="uplaod-btn">
          <input
            {...registerProps}
            ref={ref}
            accept={props.accept}
            id={props.id}
            multiple
            type={props.type}
            style={{ display: "none" }}
            onChange={onChange}
          />
          <Button variant="outlined" component="span" >
            <Image src={props.svg} alt="image uplaod" />
            Upload Media
          </Button>
        </label>
      </li>
    </ul>
  );
}

export default FeedButton;
